import { AnalyticService } from '../../apis/analytics';
import { FETCH_REALTIME_OVERVIEW } from '../actions.type';
import { FETCH_REALTIME_OVERVIEW_END } from '../mutations.type';

const initialState = {
  realtimeOverview: [],
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_REALTIME_OVERVIEW](context, args) {
    try {
      const { data } = await AnalyticService.fetchRealtimeOverview();
      context.commit(FETCH_REALTIME_OVERVIEW_END, data);
      return data;
    } catch (error) {
      console.error('Error fetchRealtimeOverview:', error);
    }
  },
};

export const mutations = {
  [FETCH_REALTIME_OVERVIEW_END](state, data) {
    state.realtimeOverview = data;
  },
};

export const getters = {
  realtimeOverview(state) {
    return state.realtimeOverview;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
